import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const connectionList = (params = '') => Http.get(`/admin/ventures/connections${serialize(params)}`)
export const connectionByID = (params = '') => Http.get(`/admin/ventures/connections/${params}`)
export const connectionDetail = (id) => Http.get(`/admin/ventures/connections/${id}/detail`)
export const connectionArchive = (id) => Http.post(`/admin/ventures/connections/${id}/archive`)
export const connectionUpdateSuccessFee = (id, params) => Http.patch(`/admin/ventures/connections/${id}/success-fee`, params)
